import React from "react";
import "./HexgonChart.css";

import { useEffect, useRef,useState,useMemo} from "react";
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from "chart.js";
import { Radar } from "react-chartjs-2";

import { IMG_URL} from "../../config";
// import HexgonChart from "../HexgonChart/HexgonChart";

ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
);

const styles = {
  wrapper: {
    display: "inline-block",
    background:
      "linear-gradient(145deg, #ede8f5 0%, #f5f0fd 60%, #e8e0f0 100%)",
    borderRadius: "20px",
    padding: "24px 28px 28px",
    boxShadow:
      "0 8px 32px rgba(140, 100, 200, 0.12), 0 2px 8px rgba(140, 100, 200, 0.08)",
    fontFamily: "'Segoe UI', 'Helvetica Neue', sans-serif",
    minWidth: "260px",
    maxWidth: "320px",
  },
  chartContainer: {
    width: "240px",
    height: "220px",
    margin: "0 auto 20px",
  },
  divider: {
    borderTop: "1px solid rgba(150, 100, 200, 0.15)",
    marginBottom: "16px",
  },
  title: {
    fontSize: "13px",
    fontWeight: "700",
    color: "#4a3a6a",
    marginBottom: "12px",
    letterSpacing: "0.01em",
  },
  traitRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "8px",
  },
  traitLeft: {
    display: "flex",
    alignItems: "center",
    gap: "7px",
    fontSize: "13px",
    color: "#5a4a7a",
    fontWeight: "500",
  },
  traitCount: {
    fontSize: "13px",
    fontWeight: "700",
    color: "#4a3a6a",
  },
  iconApex: { color: "#c9a020", fontSize: "14px" },
  iconForce: { color: "#7a9cc0", fontSize: "14px" },
  iconBalanced: { color: "#70b070", fontSize: "14px" },
  iconFlicker: { color: "#d0a020", fontSize: "14px" },
  iconWhisper: { color: "#8a7aaa", fontSize: "14px" },
};

export default function HexgonChart({traits = [], tierData = [],trait_map_title,trait_count_title}) {



    const tierCounts = useMemo(() => {
        const counts = {
          Apex: 0,
          Force: 0,
          Balanced: 0,
          Flicker: 0,
          Whisper: 0,
        };

        traits.forEach((t) => {
          const v = t.value;

          if (v >= 81) counts.Apex++;
          else if (v >= 61) counts.Force++;
          else if (v >= 41) counts.Balanced++;
          else if (v >= 21) counts.Flicker++;
          else counts.Whisper++;
        });

        return counts;
      }, [traits]);

    const [selectedIndex, setSelectedIndex] = useState(null);

    function findClosestLabelIndex(angleDeg, chart) {
      const totalLabels = chart.data.labels.length;
      const angleOffset = -90;
      const normalizedAngle = (angleDeg - angleOffset + 360) % 360;
      const step = 360 / totalLabels;
      return Math.round(normalizedAngle / step) % totalLabels;
    }


  const data = {
    // labels: ["A", "V", "Z", "W", "W", "W"],
    labels: traits.map(t => t.label.charAt(0).toUpperCase()),
    datasets: [
      {
        // label: "Traits",
        data: traits.map(t => t.value),

        backgroundColor: "rgba(160, 100, 220, 0.25)",
        // backgroundColor:
        //   selectedIndex !== null
        //     ? "rgba(160, 100, 220, 0.35)"
        //     : "rgba(160, 100, 220, 0.25)",

        borderColor: "rgba(140, 80, 200, 0.7)",
        borderWidth: 2,
        pointBackgroundColor: traits.map(t => t.bg_color_1),
        
        // pointBackgroundColor: [
        //   "#a060d0",
        //   "#c8a040",
        //   "#80b0c8",
        //   "#a060d0",
        //   "#60d06f",
        //   "#271dbe",
        // ],
        pointBorderWidth: 2,
        pointRadius: 5,
        pointHoverRadius: 7,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,

     onClick: (event, elements, chart) => {

      let index = null;

      if (elements.length > 0) {
        index = elements[0].index;
      } else {
        const { x, y } = event;
        const centerX =
          chart.chartArea.left +
          (chart.chartArea.right - chart.chartArea.left) / 2;
        const centerY =
          chart.chartArea.top +
          (chart.chartArea.bottom - chart.chartArea.top) / 2;

        const angle = Math.atan2(y - centerY, x - centerX);
        const angleDeg = (angle * (180 / Math.PI) + 360) % 360;

        index = findClosestLabelIndex(angleDeg, chart);
      }

      if (index !== null) {
        setSelectedIndex(index);
      }
    },

    scales: {
      r: {
        min: 0,
        max: 100,
        ticks: { display: false, stepSize: 20 },
        grid: {
          color: "rgba(160, 120, 220, 0.2)",
          lineWidth: 1,
        },
        angleLines: {
          color: "rgba(160, 120, 220, 0.2)",
          lineWidth: 1,
        },
        pointLabels: {
          color: "#7a6a9a",
          font: { size: 12, weight: "600" },
          padding: 6,
        },
      },
    },
    plugins: {
      legend: { display: false },
      tooltip: { enabled: true },
    },
    elements: {
      line: { tension: 0 },
    },
  };

  return (
    <div className="hexa-wrapper">
      <div className="hexa-title hexa-title-radio">
        <h6>
           {trait_map_title} <span></span>
        </h6>
      </div>

      <div className="hexa-chartContainer">
        <Radar data={data} options={options} />
      </div>

      <div className="hexa-divider" />

      <div className="hexa-title">
        <h6>{trait_count_title}</h6>
      </div>
      <div className="hexa-traitRow-outer">

          {Array.isArray(tierData) && (
            tierData.map((tier, index) => {

              const current = Number(tier?.percentage || 0);
              const prev = index === 0 ? 100 : Number(tierData[index - 1]?.percentage || 0);
              const next = tierData[index + 1]?.percentage ?? 0;

              const rangeStart = prev;
              const rangeEnd = current;

              return (
                <div key={tier.id} className="hexa-traitRow">
                    <div className="hexa-one">
                        <img
                          src={`${IMG_URL}/d0/${tier?.trait_icon}`}
                          alt={tier.tier_name}
                          style={{ width: 18 }}
                        />

                        <span>{tier.title || tier.tier_name} {rangeEnd+1 == 1 ? 0 : rangeEnd+1}-{rangeStart} %</span>
                    </div>
                  <span className="hexa-traitCount">
                    {tierCounts[tier.tier_name] || 0}
                  </span>

                </div>
              );
            })
            
          )}

      </div>
    </div>
  );
}
